import { create } from 'zustand';

/**
 * Global open/close state for the EOS Assistant slide-over, plus its width
 * mode (default panel width vs. nearly full width) and whether the
 * conversation-history sidebar is revealed.
 *
 * Kept in a store rather than local shell state so the assistant can be opened
 * from anywhere — the topbar trigger today, page-level entry points later.
 */
interface AssistantState {
  isOpen: boolean;
  /** When true the panel expands to nearly the full viewport width. */
  isExpanded: boolean;
  /**
   * When true the left-side conversation-history rail is shown. Off by
   * default — the chat is the primary surface; history is opt-in.
   */
  isHistoryOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  toggleExpanded: () => void;
  toggleHistory: () => void;
}

export const useAssistantStore = create<AssistantState>()((set) => ({
  isOpen: false,
  isExpanded: false,
  isHistoryOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  toggleExpanded: () => set((state) => ({ isExpanded: !state.isExpanded })),
  toggleHistory: () =>
    set((state) => ({ isHistoryOpen: !state.isHistoryOpen })),
}));
